/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { CompareElectricitySpotPricesPayload } from 'api/actions/compare-electricity-spot-prices/compare-electricity-spot-prices-payload';
import { CompareElectricitySpotPricesPathParameters } from 'api/actions/compare-electricity-spot-prices/compare-electricity-spot-prices-path-parameters';
import { CompareElectricitySpotPricesResponse } from 'api/actions/compare-electricity-spot-prices/compare-electricity-spot-prices-response';

type CompareElectricitySpotPricesQueryParameters = Record<string, any>;

/**
 * The path of the CompareElectricitySpotPrices action.
 */
export const compareElectricitySpotPricesActionPath = new SweetPath<keyof CompareElectricitySpotPricesPathParameters>(
  '/electricity-spot-price/compare',
  { path: '{param}' }
);

/**
 * Creates a contextualized CompareElectricitySpotPrices actions.
 */
export default function createCompareElectricitySpotPricesAction(axios: AxiosInstance) {
  return function compareElectricitySpotPricesAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: CompareElectricitySpotPricesQueryParameters;
    payload: CompareElectricitySpotPricesPayload;
  }) {
    const path = compareElectricitySpotPricesActionPath.original;

    return axios.post<
      CompareElectricitySpotPricesResponse,
      CompareElectricitySpotPricesResponse,
      CompareElectricitySpotPricesPayload
    >(path, payload);
  };
}
